// extracted by mini-css-extract-plugin
export default {"ResetPassword":"ResetPassword_ResetPassword__wLcrD","Form":"ResetPassword_Form__qGuo-","error":"ResetPassword_error__TfFG-","SuccessMessage":"ResetPassword_SuccessMessage__Q1UTy"};